module.exports = __webpack_public_path__ + "static/media/Background.aaadce14.svg";